import { render, staticRenderFns } from "./assistant-search.vue?vue&type=template&id=e9b99d5e&scoped=true&"
import script from "./assistant-search.vue?vue&type=script&lang=js&"
export * from "./assistant-search.vue?vue&type=script&lang=js&"
import style0 from "./assistant-search.vue?vue&type=style&index=0&id=e9b99d5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b99d5e",
  null
  
)

export default component.exports